module.exports = "/assets/134475b87b39b778a1ad34652bd31599.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VO.png
// module id = 1933
// module chunks = 0